import { Collapse } from 'antd';

import Section from 'layouts/Section/Section';

import Title from 'components/Title/Title';

import { ReactComponent as MinusIcon } from 'assets/icons/minus.svg';
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';

import styles from './FAQ.module.scss';
import list from './list';

const FAQ = () => {
  return (
    <Section>
      <Title title="Frequently asked questions">
        Explore our FAQs for common questions, or feel free to reach out to us!
      </Title>
      <Collapse
        accordion
        className={styles.faqCollapseContainer}
        defaultActiveKey={['2']}
        expandIcon={({ isActive }) =>
          isActive ? (
            <MinusIcon className={styles.iconMinus} />
          ) : (
            <PlusIcon className={styles.iconPlus} />
          )
        }
      >
        {list.map(({ key, label, content }) => (
          <Collapse.Panel
            key={key}
            header={
              <div className={styles.header}>
                <span className={styles.number}>0{key}</span>{' '}
                <span>{label}</span>
              </div>
            }
          >
            {content}
          </Collapse.Panel>
        ))}
      </Collapse>
    </Section>
  );
};

export default FAQ;
